export default __webpack_public_path__ + "static/media/tpp-puppy-preschool-discount.1b70ad69.svg";